import request from '@/utils/request'

export function getWithdrawConfig() {
  return request({
    url: '/biz/giftcard/withdraw-config/get',
    method: 'get'
  })
}

export function saveWithdrawConfig(data) {
  return request({
    url: '/biz/giftcard/withdraw-config/save',
    method: 'post',
    data
  })
}
